import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react'
import { useSaleOrderModel } from "../saleOrderModel";
import { YhOfferPrint } from "@/erp_subpackage/components/YhOfferPrint/offerPrint"
import { saleOrderService } from '../saleOrderService';
import { numberParseChina, formatNum, fmoney, momentFormat } from '@/erp_subpackage/utils/util';
import { useDictModel } from '@/erp_subpackage/pages/base/dict/dictModel';
import moment from 'moment';
export function SalePrint() {
    const { t } = useTranslation();
    const initDesc = { total: 0, discount: 0 }
    const totalDesc = { total: 0, num: 0 }
    const [settlementPartyName, setSettlementPartyName] = useState("")
    const {
        print: visible,
        selectedRow,
        loadData,
        setPrint,
    } = useSaleOrderModel();
    const [formVal, setFormVal] = useState({});
    const [maintenanceList, setMaintenanceList] = useState([]);
    const [maintenanceTotal, setMaintenanceTotal] = useState(initDesc);
    const [itemTotal, setItemTotal] = useState(initDesc);
    const [total, setTotal] = useState(totalDesc);
    useEffect(() => {
        visible && getPoDetailOne()
    }, [visible])
    //获取一条数据
    const getPoDetailOne = async () => {
        let { retData } = await saleOrderService.one(selectedRow[0].saleOrderCode);
        let { details, settlementPartyCode, customerName, ...formVal } = retData;

        let newMaintenanceTotal = { ...maintenanceTotal }
        let newItemTotal = { ...itemTotal }
        let newTotal = { ...total }
        let isRate = details?.some(item => item.discountRate !== 100);
        let newdetails = details?.sort((a, b) => a.materialCode?.localeCompare(b.materialCode, 'zh-Hans-CN', { sensitivity: 'accent' })).sort((a, b) => a.shelfCode?.localeCompare(b.shelfCode, 'zh-Hans-CN', { sensitivity: 'accent' })).map((item, index) => {
            newMaintenanceTotal.total += Number(item.num) * Number(item.price)
            newMaintenanceTotal.discount = item.discountRate
            newTotal.num += Number(item.num)
            let { price, discountRate, amount } = item

            return {
                ...item,
                No: index + 1,
                notAmount: Number(item.num) * Number(item.price),
                price: fmoney(price, 2),
                isRate,  //看是否有折扣
                taxPrice: fmoney(formatNum(Number(price) * Number(discountRate) / 100), 2),
                amount: fmoney(amount, 2)
            }
        })

        // if (settlementPartyCode === "settle-party.internal") {
        //     setSettlementPartyName(shopName)
        // } else if (settlementPartyCode && (settlementPartyCode?.indexOf("man") !== -1 || settlementPartyCode?.indexOf("scn") !== -1)) {
        //     let { value: customerCode } = getTreeNodeOne(settlementPartyCode)[0]
        //     setSettlementPartyName(getFindItem(customerCode, CustomerData).name)
        // } else {
        //     setSettlementPartyName(customerName)
        // }
        //这里做最后一行汇总信息展示
        // newdetails?.push({
        //     num: newTotal.num,
        //     No: "",
        //     materialCode: "合计",
        //     amount: fmoney(formVal.totalAmount, 2)
        // })
        if (retData) {
            setMaintenanceList(newdetails ?? []);
            setFormVal({ ...formVal, isRate, settlementPartyCode, customerName, })
            setMaintenanceTotal(newMaintenanceTotal)
            setItemTotal(newItemTotal)
        }
    };
    const printNum = async () => {
        await saleOrderService.printNum(selectedRow[0].id);
        await loadData()
    }
    const onCancel = () => {
        setPrint(false)
        setMaintenanceList([]);
        setFormVal({})
        setMaintenanceTotal(initDesc)
        setItemTotal(initDesc)
    }
    const columns = [
        {
            title: t(`sale.view.SaleOrderPrint.序号`),
            dataIndex: 'No',
        },
        {
            title: t(`sale.view.SaleOrderPrint.商品编号`),
            dataIndex: 'materialCode',
        },
        {
            title: t(`sale.view.SaleOrderPrint.商品名称`),
            dataIndex: 'materialName',
        },
        {
            title: t(`sale.view.SaleOrderPrint.单位`),
            dataIndex: 'unitName',
        },
        {
            title: t(`sale.view.SaleOrderPrint.数量`),
            dataIndex: 'num',
        },
        {
            title: t(`sale.view.SaleOrderPrint.单价`),
            dataIndex: 'price',
        },
        ...(formVal.isRate ? [{
            title: t(`sale.view.SaleOrderPrint.折扣`),
            dataIndex: 'discountRate',
            render: (text, record) => record.isRate ? text + "%" : ""
        }] : []),
        {
            title: t(`sale.view.SaleOrderPrint.金额`),
            dataIndex: 'amount',
        },
        {
            title: t(`sale.view.SaleOrderPrint.仓库`),
            dataIndex: 'warehouseName',
        },
        {
            title: t(`sale.view.SaleOrderPrint.货位`),
            dataIndex: 'shelfCode',
        },
    ]
    const XJHeader = [
        {
            fieldLabel: `${t(`sale.view.SaleOrderPrint.车牌号`)}：`,
            fieldValue: formVal?.licensePlate
        },
        {
            fieldLabel: `${t(`sale.view.SaleOrderPrint.底盘号`)}：`,
            fieldValue: formVal?.vin
        },

        {
            fieldLabel: `${t(`sale.view.SaleOrderPrint.结算方`)}：`,
            className: "li-right",
            fieldValue: settlementPartyName,
        },
    ]
    //头部与底部展示
    const printShow = {
        header: [
            {
                fieldLabel: `${t(`sale.view.SaleOrderPrint.销售订单号`)}：`,
                fieldValue: formVal?.saleOrderCode,
                className: "w30"
            },
            {
                fieldLabel: `${t(`sale.view.SaleOrderPrint.客户名称`)}：`,
                fieldValue: formVal?.customerName,
            },
            {
                fieldLabel: `${t(`sale.view.SaleOrderPrint.打印日期`)}：`,
                fieldValue: moment(new Date()).format("YYYY-MM-DD HH:mm"),
                //className: "li-right"
            },
            {
                fieldLabel: `${t(`sale.view.SaleOrderPrint.联系人`)}：`,
                fieldValue: formVal?.contact,
                className: "w30"
            },
            {
                fieldLabel: `${t(`sale.view.SaleOrderPrint.电话`)}：`,
                fieldValue: formVal?.phone
            },
            {
                fieldLabel: `${t(`sale.view.SaleOrderPrint.销售日期`)}：`,
                fieldValue: momentFormat(formVal?.createTime),
                className: "li-right"
            },
            {
                fieldLabel: `${t(`sale.view.SaleOrderPrint.支付方式`)}：`,
                fieldValue: formVal.payMethodName,
                // className: "li-right"
            },
        ],
        footerPeople: [
            {
                fieldLabel: `${t(`sale.view.SaleOrderPrint.制表人`)}：`,
                fieldValue: formVal?.createUser
            },
            {
                fieldLabel: "",
                fieldValue: "",
            },
            {
                fieldLabel: "",
                fieldValue: "",
            },
            // {
            //     fieldLabel: "销售：",
            //     fieldValue: ""
            // },
            // {
            //     fieldLabel: "出纳：",
            //     fieldValue: ""
            // },
            // {
            //     fieldLabel: "会计：",
            //     fieldValue: ""
            // },
            // {
            //     fieldLabel: "仓库：",
            //     fieldValue: maintenanceList[0]?.warehouseName
            // },

        ],
        note: {
            fieldLabel: `${t(`sale.view.SaleOrderPrint.备注`)}：`,
            fieldValue: formVal?.note
        },
        Total: {
            numAll: maintenanceList.length,
            receivedAmountChina: numberParseChina(formVal?.receivedAmount),
            receivedAmount: fmoney(formVal?.receivedAmount, 2)
        },

        // Total: [
        //     {
        //         fieldLabel: "大写金额 THE SUM OF：",
        //         fieldValue: numberParseChina(formVal?.receivedAmount as string)
        //     },
        //     {
        //         fieldLabel: "结算类型 Payment Type：",
        //         fieldValue: getTreeNodeName(formVal?.payType as string)
        //     },
        // ],
    }
    const headerTitle = {
        // title: "天津欧豪富港汽车贸易有限公司销售单"
        title: `${formVal.bentityName}${t(`sale.view.SaleOrderPrint.销售订单`)}`

    }
    return (
        <YhOfferPrint
            title={t(`sale.view.SaleOrderPrint.销售订单打印详情`)}
            type=""
            visible={visible}
            onClose={onCancel}
            printNum={printNum}
            columns={columns}
            dataSource={maintenanceList.filter(item => item.num !== 0)}
            printShow={printShow}
            headerTitle={headerTitle}
        />
    )
}